import type { ReactNode } from 'react';

import * as styles from './TabPanel.css';

type Props = {
  value: number;
  index: number;
  children: ReactNode;
};

export default function TabPanel({ value, index, children }: Props) {
  return (
    <div role="tabpanel" hidden={value !== index} className={styles.root}>
      {value === index && children}
    </div>
  );
}
